<template>
  <div :class="cssClasses">
    <div class="eventInformation networkInformation ncldmsc2022">
      <v-container class="pt-0">
        <v-layout row wrap>
          <v-flex sm7 class="information">
            <h4 v-if="extract('event.open')">Register for the</h4>
            <h3
              v-html="
                extract('event.content.body.title') || extract('event.name')
              "
            ></h3>
            <div
              class="event-description"
              v-html="extract('event.content.body.description')"
            ></div>
            <table
              class="event-sections"
              v-if="extract('event.content.body.sections')"
            >
              <tr
                v-for="(obj, num) in extract('event.content.body.sections')"
                v-bind:key="num"
              >
                <td class="rowLabel">
                  <h4 class="section-title">
                    {{
                      extract("event.content.body.sections." + num + ".title")
                    }}:
                  </h4>
                </td>
                <td
                  v-html="
                    extract('event.content.body.sections.' + num + '.html')
                  "
                ></td>
              </tr>
            </table>

            <div
              class="event-closing"
              v-if="extract('event.content.body.closing')"
              v-html="extract('event.content.body.closing')"
            ></div>
            <div>
              <span
                class="capacity-notice"
                v-if="!loading && availableSlots < 1"
                >The network is currently at capacity, but sign up below to be
                added to the wait list and we'll email you if a spot opens
                up.</span
              >
            </div>
          </v-flex>
          <v-flex sm4 offset-sm1 class="callout">
            <!-- IF DEFAULT ASIDE -->
            <div class="whiteBox pa-4 mb-4 hidden-xs-only" v-if="hasAside">
              <div v-if="hasAside">
                <div v-if="defaultAside">
                  <!-- <p><img src="@/assets/es/Summit_SideCallout.svg" style='max-height: 200px; max-width:100%' /></p> -->
                  <p>
                    <v-img src="@/assets/es/Summit_01@2x.jpg" />
                  </p>
                  <p>
                    <v-img src="@/assets/es/Summit_02@2x.jpg" />
                  </p>
                </div>
                <div v-else class="customAside">
                  <AmazeDynamicComponent
                    v-bind:template="extract('event.content.aside.html')"
                  ></AmazeDynamicComponent>
                </div>
              </div>
            </div>
            <!-- END DEFAULT ASIDE -->
            <div id="refund-dialog">
              <v-dialog v-model="dialog" max-width="500px">
                <v-btn
                  slot="activator"
                  color="primary"
                  style="display: none"
                  id="refund-dialog-button"
                  class="mb-4 mt-4 ml-0"
                >
                  Learn more about RTI's refund and cancellation policy
                </v-btn>
                <v-card>
                  <v-card-title>
                    <h3 class="headline">Refund and Cancellation Policy</h3>
                  </v-card-title>
                  <hr class="thick" />

                  <v-card-text>
                    <v-layout wrap>
                      <div class="pa-2 mb-2">
                        <p>
                          The {{ event.name }} Cancellation and Refund Policy
                          will be as follows to assure consistency and is
                          applicable to this network.
                        </p>
                        <p>
                          {{ event.name }} registration canceled online on or
                          before {{ getFormattedDate(event.refund_expiry) }} is
                          refundable if already paid, or not due if not already
                          paid. In order for your cancellation to be received,
                          email
                          <a href="mailto:educationservices@rti.org ">
                            educationservices@rti.org</a
                          >
                          no later than
                          {{ getFormattedDate(event.refund_expiry) }}.
                        </p>
                      </div>
                    </v-layout>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer />
                    <v-btn color="blue darken-1" flat @click="dialog = false"
                      >Close</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </div>

    <!-- BEGIN THE FORMATIONING -->
    <div class="registrationForm" v-if="!loading">
      <div class="text-xs-center" v-if="!extract('event.open')">
        <h4>Registration is closed for this network.</h4>
      </div>
      <v-form ref="regForm" v-model="valid" v-if="extract('event.open')">
        <v-container>
          <v-layout row wrap>
            <v-flex md6>
              <h3>
                Registration
                <small>Required fields <span class="star">*</span></small>
              </h3>

              <h5>District Information</h5>
              <v-text-field
                v-model="districtName"
                required
                :rules="rules.district"
              >
                <template slot="label"
                  >District Name<span class="star">*</span></template
                >
              </v-text-field>

              <h5>District Address</h5>
              <AmazeAddress :address="districtAddress"></AmazeAddress>

              <h5>District Billing Address (check if the same as above)</h5>
              <v-checkbox
                v-model="billingSame"
                :label="`Use District Address`"
              ></v-checkbox>
              <AmazeAddress
                v-if="!billingSame"
                :address="billingAddress"
              ></AmazeAddress>

              <div v-if="membershipOptions" id="MembershipOptionsContainer">
                <h5>Membership Options<span class="star">*</span></h5>
                <p>Please select from the options below.</p>
                <div v-for="n in membershipOptions" :key="n.name" class="mb-3">
                  <v-checkbox
                    v-model="membershipOption"
                    :label="n.name"
                    :value="n.value"
                    required
                    :rules="rules.option"
                    :hint="n.hint"
                    persistent
                    persistent-hint
                  ></v-checkbox>
                </div>

                <p>
                  <strong
                    >To qualify for the group discount of $8,000, your district
                    will need to register all participants at one time.</strong
                  >
                  Enter all names of known participants, and TBD for unknown
                  participants, if needed.
                </p>
              </div>

              <div v-if="membershipOption">
                <div>
                  <h5>District Leads</h5>
                  <p>
                    <strong
                      >Number of district leads (total registrants)<span
                        class="star"
                        >*</span
                      ></strong
                    >
                  </p>
                  <p>
                    After selecting the number of district leads you wish to
                    register, you will be able to enter information for each.
                  </p>

                  <v-select
                    :items="registrantSlots"
                    label="Select number of leads"
                    v-model="registrants"
                    required
                    :rules="rules.size"
                    @change="initializeSlots"
                  ></v-select>

                  <div v-if="registrants > 0">
                    <h5>Lead Information</h5>
                    <p>
                      Please enter the registration information for each lead.
                      <strong>Lead 1 is your primary contact</strong>.
                    </p>

                    <template v-for="(obj, num) in registrant">
                      <div class="registrant" :key="num">
                        <h6>Lead {{ num + 1 }}</h6>
                        <v-text-field
                          v-model="registrant[num].name"
                          :rules="
                            registrationIsSingle || num < 1 ? rules.name : []
                          "
                        >
                          <template slot="label">
                            Lead {{ num + 1 }}: Name<span
                              v-if="registrationIsSingle || num < 1"
                              class="star"
                              >*</span
                            >
                          </template>
                        </v-text-field>
                        <AmazeEmailAddressInput
                          v-model="registrant[num].email"
                          :required="registrationIsSingle || num < 1"
                        >
                          <template slot="label"
                            >Lead {{ num + 1 }}: E-mail</template
                          >
                        </AmazeEmailAddressInput>

                        <v-text-field
                          v-model="registrant[num].role"
                          :rules="
                            registrationIsSingle || num < 1 ? rules.role : []
                          "
                        >
                          <template slot="label">
                            Lead {{ num + 1 }}: Role<span
                              v-if="registrationIsSingle || num < 1"
                              class="star"
                              >*</span
                            >
                          </template>
                        </v-text-field>

                        <v-select
                          :items="networks"
                          v-model="registrant[num].extra_attributes.network"
                          :rules="
                            registrationIsSingle || num < 1 ? rules.lead : []
                          "
                        >
                          <template slot="label">
                            Which network will Lead {{ num + 1 }} participate in
                            :
                            <span
                              v-if="registrationIsSingle || num < 1"
                              class="star"
                              >*</span
                            >
                          </template>
                        </v-select>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </v-flex>
            <v-flex xs12 sm12 md12 lg12 class="mt-20">
              <div class="submit-wrapper" v-if="registrants > 0">
                <div class="submit-success" v-if="this.submittedSuccessfully">
                  <h5>Success!</h5>
                  <p>
                    <strong
                      >Thank you for registering for the
                      <span
                        v-html="
                          extract('event.content.body.title') ||
                          extract('event.name')
                        "
                      ></span
                      >!</strong
                    >
                    You should receive a confirmation email shortly. If you do
                    not receive an email, please contact
                    <a :href="'mailto:' + contactAddress">{{
                      contactAddress
                    }}</a
                    >.
                  </p>
                </div>
                <div class="submit-incomplete" v-else>
                  <h5 v-if="terms || acknowledgement">Terms and Conditions</h5>
                  <div v-if="terms || acknowledgement">
                    <div id="netTermsWrapper">
                      <iframe
                        id="terms"
                        :src="termsEmbedUrl"
                        width="100%"
                        height="400"
                        embedded="true"
                        frameborder="0"
                      ></iframe>
                      <a
                        class="hidden"
                        ref="termsDownload"
                        download="terms.pdf"
                        target="_blank"
                        :href="terms"
                      >
                        <v-icon>cloud_download</v-icon> Download PDF
                      </a>
                      <v-btn
                        @click="downloadTerms"
                        class="mx-0"
                        color="secondary"
                      >
                        <v-icon>cloud_download</v-icon>&nbsp; Download PDF
                      </v-btn>
                    </div>
                    <div
                      v-if="acknowledgement"
                      v-html="acknowledgement"
                      id="acknowledgement"
                    ></div>
                    <div v-if="acknowledgement">
                      <v-checkbox
                        required
                        :rules="rules.acknowledge"
                        v-model="acknowledge"
                        :disabled="acknowledge"
                        :label="`I acknowledge that I have read and accept the terms and conditions.`"
                      ></v-checkbox>
                    </div>
                  </div>

                  <v-btn
                    v-if="!submitted"
                    class="ml-0"
                    color="primary"
                    @click="submitRegistration()"
                    >Submit Registration</v-btn
                  >

                  <v-progress-circular v-else indeterminate />
                </div>
              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </div>

    <!-- END THE FORMATIONING -->
  </div>
</template>
<style scoped lang="scss">
#netTermsWrapper {
  padding-bottom: 20px;
  padding-top: 20px;
}

#terms {
  max-height: 400px;
  overflow-y: scroll;
  overflow: scroll;
  margin-bottom: 10px;
  width: 100%;
  border: 1px solid #707070;
}
</style>

<script>
import moment from "moment";
import AmazeAddress from "@/components/Widgets/AmazeAddress";
import registrationConfigMixin from "@/mixins/registrationConfigMixin.js";
import registrationMixin from "@/mixins/registrationMixin.js";
import { unstable_batchedUpdates } from "preact/compat";
import Vue from "vue";
export default {
  mixins: [registrationConfigMixin, registrationMixin],
  data() {
    return {
      dialog: false,
      loading: true,
      valid: false,
      submitted: false,
      acknowledge: false,

      availableSlots: 0,
      maxRegistrants: 0,
      totalAttendees: 0,

      schoolName: "",
      districtName: "",
      stateName: "NC",

      districtAddress: {
        street: null,
        city: null,
        state: "NC",
        zip: null
      },

      billingSame: false,
      cachedBilling: null,
      billingAddress: {
        street: null,
        city: null,
        state: "NC",
        zip: null
      },

      membershipOption: null,

      membershipOptions: [
        {
          name: "Individual Participation - $1,500",
          value: "Individual Participation $1500",
          hint: "Register 1 to 5 participants for $1,500 per person."
        },
        {
          name: "Group Participation - $8,000",
          value: "Group Participation $8000",
          hint: "Register 6 to 10 participants for $8,000 total for the group."
        }
      ],

      networks: ["Math", "Science"],

      registrants: 0,
      numRegistrants: 0,
      registrant: [
        {
          name: "",
          email: null,
          role: null,
          extra_attributes: {
            network: null
          }
        }
      ],
      submittedSuccessfully: false,
      rules: {
        name: [(v) => !!v || "Name is required."],
        email: [
          (v) => !!v || "Email is required.",
          (v) => /@/.test(v) || "Please enter a valid email."
        ],
        option: [
          (v) => (!!v && v.length > 0) || "Membership option is required."
        ],
        role: [(v) => !!v || "Role is required."],
        lead: [(v) => !!v || "Network participation is required."],
        school: [(v) => !!v || "School name is required."],
        district: [(v) => !!v || "District name is required."],
        state: [(v) => !!v || "State is required."],
        size: [(v) => !!v || "Team size is required."],
        acknowledge: [(v) => !!v || "Please accept the terms and conditions."]
      },
      event: {},
      leadsError: false
    };
  },
  watch: {
    registrant: {
      deep: true,
      handler(val) {
        // console.log(val);
      }
    },
    membershipOption: function (newVal, oldVal) {
      if (this.registrationIsSingle) {
        this.maxRegistrants = 5;
        this.registrants = 0;
      } else {
        this.maxRegistrants = 10;
        this.registrants = 0;
      }
    },
    billingSame: function (newVal, oldVal) {
      if (newVal) {
        this.cachedBilling = this.billingAddress;
        // Billing is same as school.
        this.billingAddress = this.schoolAddress;
      } else {
        if (this.cachedBilling) {
          this.billingAddress = this.cachedBilling;
        } else {
          this.billingAddress = this.defaultSchool;
        }
      }
    }
  },
  computed: {
    leadsCountError() {
      return this.teamMembers.length < 1;
    },
    teamMembers() {
      return this.registrant.filter((reg) => {
        return reg.name && reg.name.length && reg.email && reg.email.length;
      });
    },
    termsEmbedUrl() {
      return (
        "https://docs.google.com/viewer?url=" +
        this.terms +
        "&embedded=true&chrome=true"
      );
    },
    defaultSchool() {
      return {
        street: null,
        city: null,
        state: null,
        zip: null
      };
    },
    content() {
      // var defaults = {};
      return event.content ? event.content : false;
    },
    id() {
      return this.extract("event.id");
    },
    terms() {
      return this.extract("event.content.terms", false);
    },
    acknowledgement() {
      return this.extract("event.content.acknowledgement", false);
    },
    showWaiver() {
      // By default, we should be showing the waiver. However, if the waiver meta entry is set
      // to false, that indicates we should not show the waiver.
      return this.extract("event.content.meta.waiver", true);
    },
    hasAside() {
      var aside = this.extract("event.content.aside.custom");
      return aside !== null && typeof aside !== "undefined";
    },
    defaultAside() {
      return (
        !this.extract("event.content.aside.custom") ||
        !this.extract("event.content.aside.html")
      );
    },
    registrationIsSingle() {
      return this.membershipOption === "Individual Participation $1500";
    },
    registrantSlots() {
      let slots = [];
      for (
        let i = this.registrationIsSingle ? 1 : 6;
        i <= this.maxRegistrants;
        i++
      ) {
        if (i === 1) {
          slots.push({ text: i + " lead", value: i });
        } else {
          slots.push({ text: i + " leads", value: i });
        }
      }
      return slots;
    },
    contactAddress() {
      return process.env.VUE_APP_CONTACT_ADDRESS;
    },
    loaded() {
      return !this.loading;
    },
    showSubmitPrompt() {
      return !this.submittedSuccessfully && this.registrants > 0;
    }
  },
  methods: {
    downloadTerms: function () {
      this.$refs.termsDownload.click();
    },
    getFormattedDate: function (date) {
      return moment(date, "YYYY-MM-DD").format("MM/DD/YYYY");
    },
    extract: function (valueString, defaultValue) {
      var keys =
        valueString && valueString.length ? valueString.split(".") : [];

      var numKeys = keys.length;

      var object = null;

      // Set null as default value if not defined.
      if (typeof defaultValue === "undefined") {
        defaultValue = null;
      }

      if (numKeys > 0 && keys[0] !== null && this.hasOwnProperty(keys[0])) {
        object = this[keys[0]];
      } else {
        return defaultValue;
      }

      for (var i = 1; i < numKeys; i++) {
        var key = keys[i];
        if (key !== null && object !== null && object.hasOwnProperty(key)) {
          object = object[key];
        } else {
          return defaultValue;
        }
      }

      return object;
    },
    initializeSlots() {
      let backup = this.registrant;
      this.registrant = [];
      for (let person = 0; person < this.registrants; person++) {
        if (backup[person]) {
          this.registrant[person] = backup[person];
        } else {
          Vue.set(this.registrant, person, {
            name: "",
            email: null,
            role: null,
            extra_attributes: {
              network: null
            }
          });
        }
      }
    },
    submitRegistration() {
      if (this.$refs.regForm.validate() && !this.leadsCountError) {
        this.submitted = true;

        if (this.terms) {
          this.registrant[0].terms = this.acknowledge;
        }

        let team = this.registrationIsSingle
          ? this.registrant
          : this.registrant.map(function (member) {
            if (!member.name) {
              member.name = "TBD";
            }

            if (!member.email) {
              member.email = "TBD";
            }

            if (!member.role) {
              member.role = "TBD";
            }

            return member;
          });

        let data = {
          school: null,
          district: this.districtName,
          state: this.districtAddress.state,
          team_total: this.registrants,
          registration_event_id: this.extract("event.id"),
          registration_team_member: team,
          single_registration: false,
          extra_attributes: {
            "District Address": this.districtAddress,
            "Billing Address": this.billingAddress,
            "Membership Option": this.membershipOption
          }
        };

        this.$http.post("registrations", data).then(
          (response) => {
            this.submittedSuccessfully = true;
          },
          (response) => {
            this.submitted = false;
            this.$store.commit("updateMessage", {
              message:
                "There was a problem saving your registration. Please try again or contact support.",
              snackbar: true
            });
          }
        );
      } else {
        this.leadsError = true;
        this.$store.commit("updateMessage", {
          message: "Required fields are missing. Please review the form.",
          snackbar: true
        });
      }
    }
  },
  mounted() {
    this.$http
      .get(
        "event/" +
          (this.$route.params.slug || this.$route.path.split("/").pop())
      )
      .then(
        (response) => {
          this.event = response.data.data[0];

          this.totalAttendees = this.extract("event.total_attendees") || 0;
          this.maxAttendees = this.extract("event.max_attendees") || 0;

          this.availableSlots = Math.max(
            0,
            this.maxAttendees - this.totalAttendees
          );

          this.maxRegistrants = this.extract("event.max_per_team");

          this.loading = false;
        },
        // eslint-disable-next-line handle-callback-err
        (error) => {
          this.$router.push("/404");
        }
      );
  },
  components: {
    AmazeAddress
  }
};
</script>
